import type { ReactNode } from 'react';

interface FormLayoutProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
}

export function FormLayout({ children, title, subtitle }: FormLayoutProps) {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {(title || subtitle) && (
        <div className="mb-8 text-center">
          {title && <h2 className="text-2xl font-bold text-gray-900">{title}</h2>}
          {subtitle && <p className="mt-2 text-gray-600">{subtitle}</p>}
        </div>
      )}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 sm:p-8">
        {children}
      </div>
    </div>
  );
}
